var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfessionalDetails({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2501 13.25H13.2626M18.2501 5.75V3.25C18.2501 2.58696 17.9867 1.95107 17.5178 1.48223C17.049 1.01339 16.4131 0.75 15.7501 0.75H10.7501C10.087 0.75 9.45115 1.01339 8.98231 1.48223C8.51347 1.95107 8.25008 2.58696 8.25008 3.25V5.75M25.7501 14.5C22.0411 16.9487 17.6945 18.2541 13.2501 18.2541C8.80564 18.2541 4.45909 16.9487 0.750076 14.5M3.25008 5.75H23.2501C24.6308 5.75 25.7501 6.86929 25.7501 8.25V20.75C25.7501 22.1307 24.6308 23.25 23.2501 23.25H3.25008C1.86936 23.25 0.750076 22.1307 0.750076 20.75V8.25C0.750076 6.86929 1.86936 5.75 3.25008 5.75Z",
    stroke: "#147B58",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessionalDetails);
export default __webpack_public_path__ + "static/media/ProfessionalDetails.057dcc48c135cf3ba28159a70b43ccd3.svg";
export { ForwardRef as ReactComponent };